/* eslint-disable array-callback-return */
/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState, useRef } from 'react';
import clsx from 'clsx';
import { useParams } from "react-router-dom";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import customStyles from "../../../../../assets/styles/customStyles";
import { LeftSide, RightSide, LineForm } from "./Blocks";
import { useDispatch, useSelector } from "react-redux";
import younoteAdminActions from "../../../../YounoteAdmin/Product/redux/actions";
import adminActions from "../../../../Admin/Setup/redux/actions";
import { toast } from 'react-toastify';
import { Image } from "antd";
import dayjs from 'dayjs';
import crudActions from "../../../../CRUD/redux/actions";
import actions from "../../redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import productSetupActions from "../../../../Product/Setup/redux/actions";
import unitActions from "../../../../Product/Setup/redux/actions";
import {
    checkCRUDViewPermission, includeGstSettings, gstCalculation, storageSetItem, checkPosProductView,
    checkProductSearch, checkCRUDPermission, scrollToErrorSidebar, checkComponentPermission, idNamingConversion
} from "../../../../../helpers/utilities";
import productActions from "../../../../Product/Product/redux/actions";
import { AESDecrypt } from "../../../../../helpers/Crypto";
import gstActions from "../../../../Admin/Setup/redux/actions";
import { emptyValidation, customNumberValidation, customNumberValidationQuantity } from "../../../../../helpers/validation";
import { useEventListener } from "../../../../../helpers/useEventListener";
import logoImg from "../../../../../assets/images/logo.png";
import closeImg from "../../../../../assets/images/icon_menus/Close Button.svg";
import { NavLink } from "react-router-dom";
import SalesModal from "../../../../Shared/components/SalesModal";
import { CustomModal } from "../../../../Shared/components/DeleteModal";
import { getRequest } from '../../../../../helpers/axiosClient';



const StoreSalesCreate = (props) => {
    const { businessDetails, parameterDetails } = useSelector(state => state.homeReducer);
    const { readDetails, readLoader } = useSelector(state => state.crudReducer);
    const { productGstdetails, mopDetails, hsnDetails } = useSelector(state => state.adminSetupReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const { locationDetails } = useSelector(state => state.productSetupReducer);
    const { getList, getData, createDetails, createError, createData, createLoader, editDetails, editError, editLoader, editData } = useSelector(state => state.crudReducer);
    const { clientProductcatalogueDetails } = useSelector(state => state.younoteAdminProductReducer);
    const { customerDetails } = useSelector(state => state.salesManagementReducer);
    const { unitMesurementdetails, productGroupDetails } = useSelector(state => state.productSetupReducer);
    const { myProductdetails, productPrices } = useSelector(state => state.productProductReducer);
    const [showNameDesc, setShowNameDesc] = useState(checkPosProductView());
    const saleModalRef = useRef(null);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const { history } = props;
    const [loadMore, setLoadMore] = useState(false);
    const [activeInputs, setActiveInputs] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    let { values, type } = useParams();
    const [skip, setSkip] = useState(0);
    const [search, setSearch] = useState('');
    const [pos, setPos] = useState({});
    const limit = 100;
    const sortOrder = "desc";
    const sortBy = "id";
    const prevSearch = usePrevious(search);
    const [units, setUnits] = useState([]);
    const timeoutRef = useRef(null);
    const [selected, setSelected] = useState([]);
    const [productId, setProductId] = useState('');
    const [clickProductId, setClickProductId] = useState('');
    const [priceList, setPriceList] = useState([]);
    const dispatch = useDispatch();
    const [form, setForm] = useState({});
    const [error, setError] = useState({});
    const prevReadDetails = usePrevious(readDetails);
    const [visible, setVisible] = useState(false);
    const [view, setView] = useState(false);
    const [headerView, setHeaderView] = useState(false);
    const [status, setStatus] = useState('');
    const [lineForm, setLineForm] = useState({});
    const [errorLineForm, setErrorLineForm] = useState({});
    const [lineId, setLineId] = useState({});
    const [lineError, setLineError] = useState({});
    const [changeSelected, setChangeSelected] = useState(false);
    const [PaymentProcess, setpaymentProcess] = useState(false);
    const [products, setProducts] = useState([]);
    const [changeReceipt, setChangeReceipt] = useState(false);
    const [returnProducts, setReturnProducts] = useState([]);
    const priceRef = useRef(null);
    const [topBar, setTopBar] = useState({ 'productSearch': checkProductSearch() });
    const [print, setPrint] = useState(false);
    const [viewType, setViewType] = useState('tile');
    const [toggle, setToggle] = useState(false);
    const [newSales, setNewSales] = useState(false);
    const [viewBatch, setViewBatch] = useState(false);
    const [batch, setBatch] = useState([]);
    const [, setBatchDetails] = useState([]);
    const [autoMark, setAutoMark] = useState(false);
    const [selectedBatchId, setSelectedBatchId] = useState([]);
    const [availableQuantity, setAvailableQuantity] = useState('');

    useEffect(() => {
        if (roleManagement !== '' && (checkCRUDViewPermission('Store Sales', 'create', history, 'Sales')
            || checkCRUDViewPermission('Store Sales', 'edit', history, 'Sales'))
        ) {
            const decryptedValues = AESDecrypt(values);
            if (decryptedValues) {
                if (type === 'create') {
                    setPos(decryptedValues);
                    loadTasks(decryptedValues.posId, '');
                } else {
                    if (type === 'view') {
                        setHeaderView(true);
                        setpaymentProcess(true);
                    }
                    loadTasks('', decryptedValues);
                }
            } else {
                history.go(-1);
            }
        }
        return () => {
            dispatch({ type: actions.CLEAR_MANAGEMENT_DETAILS_START });
        }

    }, [roleManagement]);


    const handleNewSales = () => {
        let b = [];
        if (form?.salesType === 'Sale Return') {
            b = selected.filter((el) => { return returnProducts.find(e => e === el.id && !el.isReturned) });
        } else {
            b = selected;
        }
        if (headerView || b?.length === 0) {
            newSalesCallBack();
        } else {
            setNewSales(true);
        }
    }

    const handleNewSalesConfirm = () => {
        handleSubmit('CREATED');
    }

    const newSalesCallBack = () => {
        setForm({
            type: 'create',
            storeSalesUserId: form?.storeSalesUserId, salesType: form?.salesType || pos?.type, billFormat: form.billFormat
        });
        setError({});
        setLineError({});
        setLineForm({});
        setErrorLineForm({});
        setChangeSelected(false);
        setpaymentProcess(false);
        setHeaderView(false);
        setPriceList([]);
        setSelected([]);
        setSearch('');
        dispatch({ type: crudActions.READ_DETAILS_START, id: form?.posId, url: "point-of-sales" });
        setNewSales(false);
    }

    const loadTasks = (posId = '', id = '') => {
        if (posId !== '') {
            dispatch({ type: crudActions.READ_DETAILS_START, id: posId, url: "point-of-sales" });
        } else {
            dispatch({ type: crudActions.READ_DETAILS_START, id: id, url: "store-sales" });
        }
        productApi();
        // dispatch({
        //     type: productActions.MYPRODUCT_DETAILS_START, url: 'client-products', filter: {
        //         where: { "and": [{ status: 'ACTIVE' }] },
        //         order: 'id  desc'
        //     }
        // });
        dispatch({
            type: unitActions.PRODUCT_GROUP_DETAILS_START, url: 'product-groups', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: unitActions.UNITMESUREMENT_DETAILS_START, url: 'unit', filter: {
                order: 'id  desc'
            }
        });
        // dispatch({
        //     type: actions.CUSTOMER_DETAILS_START, url: 'customerProfile', filter: {
        //         order: 'id desc'
        //     }
        // });
        dispatch({
            type: younoteAdminActions.CLIENT_PRODUCT_CATALOGUE_DETAILS_START
        });
        dispatch({
            type: gstActions.PRODUCTGST_DETAILS_START, url: 'productgst', filter: {
                order: 'id  desc'
            }
        });

        dispatch({
            type: adminActions.MOP_DETAILS_START, filter: {
                order: 'id  desc'
            }
        });
        locationApi();
        dispatchFilter(topBar);
        //hsnApi();
    }

    const customerApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };
        if (search !== undefined && search !== null && search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ mobile: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: actions.CUSTOMER_DETAILS_START, url: 'customerProfile',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 100,
                skip: 0
            },
        });
    }

    const customObject = (details, id) => {
        let a = details?.length && details?.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const productApi = (search = '', id = '') => {
        let filter = { ["and"]: [{ status: 'ACTIVE' }, { ["or"]: [{ transType: { eq: null } }, { transType: { eq: 'SALES' } }] }] };
        let or = { ["or"]: [] };

        let array = ['productName', 'productId', 'description', 'type', 'barcode', 'code'];
        if (search) {
            if (checkProductSearch() === 'both') {
                array = ['productName', 'code'];
            } else if (checkProductSearch() === 'name') {
                array = ['productName'];
            } else if (checkProductSearch() === 'code') {
                array = ['code'];
            }
            array.map((el) => {
                if (el === 'code') {
                    return or['or'].push({ [el]: search.trim() })
                } else {
                    return or['or'].push({ [el]: { like: '%' + search.trim() + '%' } })
                }
            });
        }

        if (or.or.length > 0) {
            filter['and'].push(or);
        }
        dispatch({
            type: productActions.MYPRODUCT_DETAILS_START, url: 'client-products',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            if (newSales) {
                newSalesCallBack();
            } else {
                toast.dismiss();
                //toast(createDetails);
                setHeaderView(true);
                setStatus(createData?.billStatus);
                setpaymentProcess(true);
                setForm({
                    ...form, ...createData,
                    invoiceDate: createData?.invoiceDate ? dayjs(createData?.invoiceDate).$d : null,
                    transactionDate: createData?.transactionDate ? dayjs(createData?.transactionDate).$d : null,
                });
                if (createData?.billStatus === 'CONFIRMED') {
                    setPrint(true);
                }
                let ids = [];
                createData?.storeSalesItems?.length && createData?.storeSalesItems?.map((el) => { return ids.push(el.id) });
                setReturnProducts(ids);
                setSelected(createData?.storeSalesItems || []);
            }

        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let error = createError.error.message;
            toast.dismiss();
            toast.error(error);
        }
    }, [createDetails, createError]);


    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            if (newSales) {
                newSalesCallBack();
            } else {
                setHeaderView(true);
                setStatus(editData?.billStatus);
                setpaymentProcess(true);
                if (editData?.billStatus === 'CONFIRMED') {
                    setPrint(true);
                }
                let ids = [];
                editData?.storeSalesItems?.length && editData?.storeSalesItems?.map((el) => { return ids.push(el.id) });
                setReturnProducts(ids);
                setSelected(editData?.storeSalesItems || []);
            }
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let error = JSON.stringify(editError.error.message);
            toast.dismiss();
            toast.error(error);
        }
    }, [editDetails, editError]);

    useEffect(() => {
        if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
            if (readDetails?.defaultCustomerId) {
                let gstSetting = includeGstSettings(businessDetails, readDetails?.defaultCustomer);
                setForm({
                    invoiceDate: new Date(),
                    customer: readDetails?.defaultCustomer,
                    customerId: readDetails?.defaultCustomerId,
                    mopId: readDetails?.defaultMopId,
                    mop: readDetails?.defaultMop,
                    partyGstId: readDetails?.defaultCustomer?.partyGstId || '',
                    storeSalesUserId: pos?.userId || form?.storeSalesUserId || readDetails?.defaultUserId,
                    storeSalesUser: form?.storeSalesUser || readDetails?.defaultUser,
                    pos: readDetails,
                    posName: readDetails?.posNumber,
                    posId: readDetails?.id,
                    salesType: form?.salesType || pos?.type,
                    type: form?.type || type,
                    billFormat: readDetails?.receiptTemplate || '',
                    includeGst: gstSetting?.includeGst || false,
                    includeDisabled: gstSetting?.includeDisabled,
                    priceIncludesTax: readDetails?.defaultCustomer?.priceIncludesTax || false,
                    roundOffAmount: 0,
                    roundOffMethod: '',
                    locationId: readDetails?.locationId,
                });
                customerApi('', readDetails?.defaultCustomerId || '');
            } else {
                // if (readDetails?.billStatus === 'CONFIRMED' && !changeReceipt) {
                //     toast.dismiss();
                //     toast.error('Sales already confirmed');
                //     history.push('/sales/sales-management/store-sales');
                // }
                if (changeReceipt) {
                    const updatedStoreSalesItems = readDetails?.storeSalesItems?.length > 0
                        ? readDetails.storeSalesItems.map((element) => {
                            const updatedElement = { ...element, quantity: -parseFloat(element.quantity) };
                            if (element?.batchDetails?.length > 0) {
                                updatedElement.batchDetails = element.batchDetails.map((batch) => ({
                                    ...batch,
                                    quantity: -parseFloat(batch.quantity),
                                }));
                            }
                            return updatedElement;
                        }) : [];
                    readDetails.storeSalesItems = updatedStoreSalesItems;
                    readDetails.billRefNum = readDetails?.cashReceiptNumber;
                    readDetails.isReturnWithReceipt = changeReceipt;
                    readDetails.salesType = 'Sale Return';
                    readDetails.originalDiscountAmount = -readDetails.discountAmount;
                    readDetails.roundOffAmount = -readDetails.roundOffAmount;
                    readDetails.discountAmount = -readDetails.discountAmount;
                    readDetails.id = '';
                    let ids = [];
                    readDetails?.storeSalesItems?.length && readDetails?.storeSalesItems?.filter((el) => { return !el.isReturned; })?.map((el) => { return ids.push(el.id) });
                    setSelected(readDetails?.storeSalesItems?.filter((el) => { return !el.isReturned; }));
                    setReturnProducts(ids);
                } else {
                    setSelected(readDetails?.storeSalesItems);
                    if (readDetails?.salesType === 'Sale Return') {
                        let ids = [];
                        readDetails?.storeSalesItems?.length && readDetails?.storeSalesItems?.map((el) => { return ids.push(el.id) });
                        setReturnProducts(ids);
                    }
                }
                readDetails?.storeSalesItems?.map((el) => { handleUnits(el?.product) })
                readDetails.duplicateRoundOffAmount = readDetails.roundOffAmount;
                readDetails.duplicateRoundOffMethod = readDetails?.roundOffMethod || '';
                let gstSetting = includeGstSettings(businessDetails, readDetails?.customer);
                setForm({
                    ...readDetails,
                    locationId: readDetails?.pos?.locationId,
                    type: form?.type || type,
                    mixedPayment: readDetails?.isMixedPayment ? true : false,
                    mixedPayments: readDetails?.isMixedPayment ? readDetails?.customerPayments : [],
                    roundOffMethod: readDetails?.roundOffMethod || '',
                    includeDisabled: gstSetting?.includeDisabled,
                    totalInvoiceAmount: parseFloat(readDetails?.invoiceAmount) - parseFloat(readDetails?.roundOffAmount || 0),
                    originalDiscountAmount: readDetails.discountAmount,
                    originalInvoiceAmount: parseFloat(readDetails?.invoiceAmount) + parseFloat(readDetails?.discountAmount),
                    invoiceDate: readDetails?.invoiceDate ? dayjs(readDetails?.invoiceDate).$d : null,
                    transactionDate: readDetails?.transactionDate ? dayjs(readDetails?.transactionDate).$d : null,
                    amountReceived: readDetails?.salesType === 'Sale' && readDetails?.customerPayments && readDetails?.customerPayments?.length > 0 ? readDetails?.customerPayments?.reduce((a, v) => a = parseFloat(a) + parseFloat(v.paymentAmount), 0) : ''
                });

                setStatus(readDetails?.billStatus);
                setChangeSelected(!changeSelected);
                customerApi('', readDetails?.customerId || '');
            }
        }
    }, [readDetails]);


    // useEffect(() => {
    //     if (businessDetails && form?.customer) {
    //         let gstSetting = includeGstSettings(businessDetails, form?.customer);
    //         setForm({
    //             ...form,
    //             includeGst: gstSetting?.includeGst || false,
    //             includeDisabled: gstSetting?.includeDisabled
    //         });
    //     }
    // }, [businessDetails, form.customerId]);

    useEffect(() => {
        if (productPrices && productPrices !== '' && productId !== '') {
            let selectedIndex = priceList?.findIndex(el => el.productId === productId);
            if (selectedIndex >= 0) {
                setPriceList(prevState => {
                    return prevState?.filter((value, i) => i !== selectedIndex)
                });
            } else {
                let data = {
                    productId: productId,
                    data: productPrices
                };
                setPriceList((prevState) => {
                    return [...prevState, data];
                });
            }
            if (productId !== 'single') {
                handlePrice(productId, productPrices, selected);
            }

            handleSinglePrice(lineForm, productPrices);
            setProductId('');
            setClickProductId('');
        }
    }, [productPrices]);


    const handleSinglePrice = (lineForm, prices) => {
        let pricePerUnit = 0; let mrp = 0; let discount = 0; let discountAmount = 0;
        // if ((prices?.priceagreement && Object.keys(prices?.priceagreement).length > 0 &&
        //     prices?.priceagreement[customObject(unitMesurementdetails, lineForm.unitId)?.name]) ||
        //     (prices?.lastprice && Object.keys(prices?.lastprice).length > 0 &&
        //         prices?.lastprice[customObject(unitMesurementdetails, lineForm.unitId)?.name]) ||
        //     (prices?.discountagreement && Object.keys(prices?.discountagreement).length > 0 &&
        //         productPrices?.discountagreement[lineForm?.unit?.name])) {
        if (parameterDetails?.aggrementSalesPrice && prices?.priceagreement && Object.keys(prices?.priceagreement).length > 0 &&
            prices?.priceagreement[customObject(unitMesurementdetails, lineForm.unitId)?.name]) {
            let result = prices?.priceagreement[customObject(unitMesurementdetails, lineForm.unitId)?.name][0];
            if (result?.price) {
                pricePerUnit = result?.price;
            }
            if (result?.mrp) {
                mrp = result?.mrp;
            }
        } else {
            if (parameterDetails?.lastSalesPrice && prices?.lastprice && Object.keys(prices?.lastprice).length > 0 &&
                prices?.lastprice[customObject(unitMesurementdetails, lineForm.unitId)?.name]) {
                let result = productPrices?.lastprice[customObject(unitMesurementdetails, lineForm.unitId)?.name];
                if (result?.price) {
                    pricePerUnit = result?.price;
                }
                if (result?.mrp) {
                    mrp = result?.mrp;
                }
            } else {

            }
        }

        if (prices?.discountagreement && Object.keys(prices?.discountagreement).length > 0 &&
            productPrices?.discountagreement[customObject(unitMesurementdetails, lineForm?.unitId)?.name]) {
            let result = productPrices?.discountagreement[customObject(unitMesurementdetails, lineForm?.unitId)?.name][0];
            if (result?.price) {
                discountAmount = result?.price || '';
            }
            if (result?.percentage) {
                discount = result?.percentage || '';
            }
        } else if (prices?.lastdiscount && Object.keys(prices?.lastdiscount).length > 0 &&
            prices?.lastdiscount[customObject(unitMesurementdetails, lineForm?.unitId)?.name]) {
            discount = prices?.lastdiscount[customObject(unitMesurementdetails, lineForm?.unitId)?.name]?.percent;
        }
        let data = {
            ...lineForm,
            'pricePerUnit': pricePerUnit || lineForm?.pricePerUnit || 0, 'maxRetailPrice': mrp || lineForm?.maxRetailPrice || 0,
            'discountPercentage': discount, 'discountAmount': discountAmount
        };
        setLineForm({
            ...data,
            ...calculateLineTotal(data)
        });
        // }
    }


    const handlePrice = (id, prices, selected) => {
        let selectedFilter = selected?.filter(el => el.productId === id);
        if (selectedFilter && selectedFilter?.length > 0) {
            // if ((prices?.priceagreement && Object.keys(prices?.priceagreement).length > 0 &&
            //     prices?.priceagreement[customObject(unitMesurementdetails, selectedFilter[0].unitId)?.name]) ||
            //     (prices?.lastprice && Object.keys(prices?.lastprice).length > 0 &&
            //         prices?.lastprice[customObject(unitMesurementdetails, selectedFilter[0].unitId)?.name]) ||
            //     (prices?.discountagreement && Object.keys(prices?.discountagreement).length > 0 &&
            //         productPrices?.discountagreement[customObject(unitMesurementdetails, selectedFilter[0].unitId)?.name])) {
            let pricePerUnit = 0; let mrp = 0; let discount = 0; let discountAmount = 0;
            if (prices?.priceagreement && Object.keys(prices?.priceagreement).length > 0 &&
                prices?.priceagreement[customObject(unitMesurementdetails, selectedFilter[0].unitId)?.name]) {
                let result = prices?.priceagreement[customObject(unitMesurementdetails, selectedFilter[0].unitId)?.name][0];
                if (result?.price) {
                    pricePerUnit = result?.price;
                }
                if (result?.mrp) {
                    mrp = result?.mrp;
                }
            } else {
                if (prices?.lastprice && Object.keys(prices?.lastprice).length > 0 &&
                    prices?.lastprice[customObject(unitMesurementdetails, selectedFilter[0].unitId)?.name]) {
                    let result = productPrices?.lastprice[customObject(unitMesurementdetails, selectedFilter[0].unitId)?.name];
                    if (result?.price) {
                        pricePerUnit = result?.price;
                    }
                    if (result?.mrp) {
                        mrp = result?.mrp;
                    }
                }
            }

            if (prices?.discountagreement && Object.keys(prices?.discountagreement).length > 0 &&
                productPrices?.discountagreement[customObject(unitMesurementdetails, selectedFilter[0].unitId)?.name]) {
                let result = productPrices?.discountagreement[customObject(unitMesurementdetails, selectedFilter[0].unitId)?.name][0];
                if (result?.price) {
                    discountAmount = result?.price || '';
                }
                if (result?.percentage) {
                    discount = result?.percentage || '';
                }
            } else if (prices?.lastdiscount && Object.keys(prices?.lastdiscount).length > 0 &&
                prices?.lastdiscount[customObject(unitMesurementdetails, selectedFilter[0].unitId)?.name]) {
                discount = prices?.lastdiscount[customObject(unitMesurementdetails, selectedFilter[0].unitId)?.name]?.percent;
            }
            const newTodos = selected.map((el) => {
                if (el.productId === id) {
                    return {
                        ...el, 'pricePerUnit': parseFloat(pricePerUnit || el.pricePerUnit || 0), 'maxRetailPrice': mrp || el.maxRetailPrice || 0,
                        'discountPercentage': discount, 'discountAmount': discountAmount
                    };
                }
                return el;
            });
            setSelected(newTodos);
            setChangeSelected(!changeSelected);
            // }
        }
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 0 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(topBar);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(topBar);
                }, 500);
            }
        }
    }, [search]);

    useEffect(() => {
        if (selected && selected?.length > 0) {
            let newTodos = selected.map((el, i) => {
                return { ...calculateLineTotal(el), lineNumber: (i + 1) };
            });
            setSelected(newTodos);
            if (form?.isReturnWithReceipt) {
                newTodos = newTodos.filter((el) => { return returnProducts.find(e => e === el.id && !el.isReturned) });
            }
            if (selected?.length === newTodos?.length) {
                calculateTotal(newTodos);
            } else {
                calculateTotal(newTodos, true);
            }
        } else {
            setSelected([]);
            calculateTotal([]);
        }
    }, [changeSelected]);

    const handlePaymentProcess = (d) => {
        if (lineForm?.productId && !checkLineForm(lineForm)) {
            toast.dismiss();
            toast.error('Your last selected line having errors. Please update or remove lines');
            return false;
        }

        setpaymentProcess(d);
    }

    const handleKeyDown = (e) => {
        if (e.altKey && e.keyCode === 83) { //ALT + S
            e.preventDefault();
            if (selected?.length > 0) {
                handleSubmit('CREATED');
            }
        } else if (e.altKey && e.keyCode === 69) { //ALT + E
            e.preventDefault();
            if (headerView && status === 'CREATED') {
                setpaymentProcess(false);
                setHeaderView(false);
                setError({})
            }
        } else if (e.altKey && e.keyCode === 80) { //ALT + P
            e.preventDefault();
            if (selected?.length > 0 && !PaymentProcess) {
                setpaymentProcess(true);
            } else if (selected?.length > 0 && PaymentProcess) {
                setPrint(true);
            }
        } else if (e.altKey && e.keyCode === 79) { //ALT + 0
            e.preventDefault();
            if (!headerView && selected?.length > 0 && PaymentProcess && form?.amountReceived) {
                handleSubmit('CONFIRMED');
            } else if (!headerView && selected?.length > 0 && PaymentProcess && form?.salesType === 'Sale Return' && form?.invoiceAmount) {
                handleSubmit('CONFIRMED')
            }
        } else if (e.altKey && e.keyCode === 78) { //ALT + N
            e.preventDefault();
            if (newSales) {
                handleNewSalesConfirm();
            } else {
                handleNewSales();
            }
        } else if (e.altKey && e.keyCode === 67) { //ALT + C
            e.preventDefault();
            history.push('/sales/sales-management/store-sales')
        } else if (e.altKey && (e.keyCode === 80 || e.keyCode === 68)) { //ALT + P ALT + D
            e.preventDefault();
            if (selected?.length > 0) {
                if (print) {
                    saleModalRef.current.handleDownload('download')
                } else {
                    setPrint(true);
                }
            } else {
                toast.dismiss();
                toast.error('Please add line values');
            }
        } else if (e.altKey && e.keyCode === 66) { //ALT + B
            e.preventDefault();
            if (PaymentProcess) {
                if (document.getElementById(idNamingConversion('Bill Discount', 'storeSales', 'TextField')))
                    document.getElementById(idNamingConversion('Bill Discount', 'storeSales', 'TextField')).focus();
            }
        } else if (e.altKey && e.keyCode === 86) { //ALT + V
            e.preventDefault();
            if (PaymentProcess) {
                if (document.getElementById(idNamingConversion('roundOffAmount', 'storeSales', 'TextField')))
                    document.getElementById(idNamingConversion('roundOffAmount', 'storeSales', 'TextField')).focus();
            }
        } else if (e.altKey && e.keyCode === 65) { //ALT + A
            e.preventDefault();
            if (PaymentProcess) {
                if (document.getElementById(idNamingConversion('Amount Received', 'storeSales', 'TextField')))
                    document.getElementById(idNamingConversion('Amount Received', 'storeSales', 'TextField')).focus();
            }
        } else if (e.altKey && e.keyCode === 82) { //ALT + R
            e.preventDefault();
            if (PaymentProcess) {
                if (document.getElementById(idNamingConversion('roundOffMethod', 'storeSales', 'DropDown')))
                    document.getElementById(idNamingConversion('roundOffMethod', 'storeSales', 'DropDown')).focus();
            }
        }
    };

    useEventListener("keydown", handleKeyDown);


    const calculateLineTotal = (el) => {
        let data = {
            cgst: '', sgst: '', igst: '', cgstPercentage: '', sgstPercentage: '', igstPercentage: ''
        };
        const amount = (el?.quantity || 0) * (el?.pricePerUnit || 0);
        let dPAmount = 0;
        let dTotal = 0;
        let gAmount = 0;

        if (el.discountPercentage !== '') {
            dPAmount = dTotal = parseFloat((amount * el.discountPercentage) / 100);
        }
        if (el.discountAmount && el.discountAmount !== '') {
            if (amount < 0) {
                dTotal = parseFloat(dPAmount) - parseFloat(el.discountAmount);
            } else {
                dTotal = parseFloat(dPAmount) + parseFloat(el.discountAmount);
            }
        }
        let tAmount = parseFloat(amount - dTotal);
        data['netAmount'] = tAmount;
        if (el.productGstId && el.includeGst) {
            let percentage = el.productGst.percentage;
            let details = {
                percentage: percentage,
                stateId: form?.customer?.stateId,
                lineAmount: tAmount || 0,
                priceIncludesTax: form?.priceIncludesTax
            };
            let gstCalc = gstCalculation(businessDetails, details, form?.customer);
            data['cgstPercentage'] = parseFloat(gstCalc.cgst);
            data['sgstPercentage'] = parseFloat(gstCalc.sgst);
            data['igstPercentage'] = parseFloat(gstCalc.igst);
            data['cgst'] = parseFloat(gstCalc.cgstAmount);
            data['sgst'] = parseFloat(gstCalc.sgstAmount);
            data['igst'] = parseFloat(gstCalc.igstAmount);
            gAmount = gstCalc.gAmount;
        }
        let result = {
            ...el,
            ...data,
            gstAmount: parseFloat(gAmount),
            discountPercAmount: dPAmount,
            discountCalcAmount: dTotal
        };
        return result;
    }

    const calculateTotal = (selected, dis = false) => {
        if (selected && selected?.length > 0) {
            let total = selected.reduce((a, v) => a = a + v.netAmount, 0);
            let discount = selected.reduce((a, v) => a = parseFloat(a) + parseFloat(v.discountAmount), 0);
            let discountPercent = selected.reduce((a, v) => {
                if (v.netAmount < 0) {
                    a = a - (((v.quantity * v.pricePerUnit) * v.discountPercentage) / 100)
                } else {
                    a = a + (((v.quantity * v.pricePerUnit) * v.discountPercentage) / 100)
                }
                return a;
            }, 0);
            let gst = selected.reduce((a, v) => a = v.includeGst ? (a + v.gstAmount) : 0, 0);
            let disAmount = dis ? 0 : parseFloat(form?.originalDiscountAmount || 0);
            let inVoiceAmount = parseFloat(parseFloat(total) + parseFloat(gst)) - disAmount;
            if (form?.priceIncludesTax) {
                inVoiceAmount = parseFloat(total) - disAmount
            }
            let totalInvoiceAmount = inVoiceAmount;
            setForm({
                ...form,
                'originalInvoiceAmount': form?.priceIncludesTax ? total : parseFloat(parseFloat(total) + parseFloat(gst)),
                'invoiceAmount': totalInvoiceAmount + parseFloat(form?.roundOffAmount || 0),
                'totalInvoiceAmount': parseFloat(inVoiceAmount),
                'netAmount': form?.priceIncludesTax ? parseFloat(parseFloat(total) - parseFloat(gst)) : total,
                'discount': parseFloat(discount + discountPercent),
                'gstAmount': gst,
                'discountAmount': dis ? 0 : parseFloat(form?.originalDiscountAmount || form?.discountAmount || 0)
            });
        } else {
            setForm({
                ...form,
                'invoiceAmount': '',
                'originalInvoiceAmount': '',
                'netAmount': '',
                'discount': '',
                'gstAmount': ''
            });
        }
    }

    const checkLineForm = (lineForm) => {
        let ret = false;
        let emptyDescription = emptyValidation('Description', lineForm?.description);
        let emptyUnit = emptyValidation('Unit', lineForm?.unitId, 'dropDown');
        let emptyPrice = customNumberValidation('Price', lineForm?.pricePerUnit);
        let emptyQuantity = customNumberValidationQuantity('Quantity', lineForm?.quantity);
        let emptyAmount = emptyValidation('Line Amount', lineForm?.netAmount);
        let checkValidation = true;
        let emptyProductGst = emptyValidation('Product GST Code', lineForm?.productGstId, 'dropDown');
        let emptyHsn = emptyValidation('HSN', lineForm?.hsnId, 'dropDown');
        if ((lineForm?.includeGst && !emptyProductGst.isValid) || (lineForm?.includeGst && !emptyHsn.isValid)) {
            checkValidation = false;
        }

        let discountAgreeMents = true;
        let total = lineForm?.quantity * lineForm?.pricePerUnit;
        if (Math.abs(total) < Math.abs(lineForm?.discountCalcAmount)) {
            discountAgreeMents = false;
        }

        let batchDetails = [];
        if (selectedBatchId?.length > 0) {
            let seBatch = batch.filter(el => selectedBatchId.includes(el.id));
            seBatch && seBatch?.length > 0 && seBatch.map((el) => {
                batchDetails.push({
                    batchId: el.id,
                    batch: el,
                    quantity: el.soldQuantity,
                    discountAmount: el.discountAmount
                })
            })
        }

        let negativeQuantityCheck = { isValid: true, errors: '' };
        if (!parameterDetails?.negativeStock && parameterDetails?.inventoryTransaction) {
            let qty = availableQuantity - Math.abs(lineForm?.quantity);
            if (qty < 0) {
                negativeQuantityCheck = { isValid: false, errors: 'There is no stocks available' }
            }
        }

        let batchQuantityError = { isValid: true, errors: '' };
        if (batchDetails?.length > 0) {
            let batchQuantity = batchDetails?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.quantity || 0)), 0);
            if (batchQuantity !== parseFloat(lineForm?.quantity)) {
                batchQuantityError = { isValid: false, errors: 'Total Selected Batch quantity should equal Line Quantity' }
            }
        }

        const emptyItem = selected.find(item => !item.pricePerUnit);
        console.log(selected.find(item => !item.pricePerUnit));
        console.log(emptyItem);

        setLineError({});
        if (emptyDescription.isValid && !emptyItem &&
            emptyUnit.isValid && discountAgreeMents &&
            emptyPrice.isValid && emptyQuantity.isValid && emptyAmount.isValid && checkValidation
            && batchQuantityError.isValid && negativeQuantityCheck.isValid) {
            ret = true;
            setErrorLineForm({});
        } else {
            setLineError({
                description: emptyDescription?.errors || false,
                unitId: emptyUnit?.errors || false,
                discountAgreeMents: !discountAgreeMents ? 'Discount amount is greater than Line amount, please correct it.' : false,
                pricePerUnit: emptyPrice?.errors || emptyItem ? 'Please enter a valid value in Price' : false,
                quantity: negativeQuantityCheck?.errors || emptyQuantity?.errors || false,
                batchQuantity: batchQuantityError?.errors || '',
                productGstId: lineForm?.includeGst && emptyProductGst?.errors ? emptyProductGst?.errors : false,
                hsnId: lineForm?.includeGst && emptyHsn?.errors ? emptyHsn?.errors : false
            });
            if (emptyItem) {
                onView(emptyItem, false, selected?.findIndex(el => el.productId === emptyItem.productId));
                setLineForm(emptyItem);
                setErrorLineForm(emptyItem);
            } else {
                onView(lineForm, false, selected?.findIndex(el => el.productId === lineForm.productId));
                setErrorLineForm(lineForm);
            }
            ret = false;
            scrollToErrorSidebar(classes);
        }

        return ret
    }

    const handleClick = async (data, quantity = '') => {
        if (lineForm?.productId === data?.id && quantity === '') {
            let selectedSIngleIndex = selected?.findIndex(el => el.productId === lineForm.productId);
            if (selectedSIngleIndex >= 0) {
                setSelected(prevState => {
                    return prevState.filter((value, i) => i !== selectedSIngleIndex)
                });
                setLineForm({});
                setErrorLineForm({});
                setLineError({});
            }
            return false;
        }

        if (lineForm?.productId && !checkLineForm(lineForm)) {
            toast.dismiss();
            toast.error('Your last selected line having errors. Please update or remove lines');
            return false;
        }
        handleToggle();
        if (form?.customerId) {
            setErrorLineForm({});
            let selectedIndex = selected?.findIndex(el => el.productId === data.id);
            if (selectedIndex >= 0 && data.id) {
                if (quantity === '') {
                    setSelected(prevState => {
                        return prevState.filter((value, i) => i !== selectedIndex)
                    });
                } else {
                    const newTodos = selected.map((el) => {
                        if (el.productId === data?.id) {
                            setLineForm({
                                ...el, 'quantity': parseFloat(parseFloat(el.quantity) + parseFloat(quantity))
                            });
                            return {
                                ...el, 'quantity': parseFloat(parseFloat(el.quantity) + parseFloat(quantity))
                            };
                        }
                        return el;
                    });
                    setSelected(newTodos);
                }
                setChangeSelected(!changeSelected);
            } else {
                let d = {
                    'lineNumber': selected?.length + 1,
                    'quantity': quantity === '' ? (form?.salesType === 'Sale' ? 1 : -1) : quantity,
                    'productId': data?.id,
                    'product': data,
                    'description': data?.description || data?.productName || '',
                    'unitId': data?.defaultSalesUnitId || data?.salesUnitId,
                    'unit': data?.defaultSalesUnit || data?.salesUnit,
                    'maxRetailPrice': parameterDetails?.productUnitPrice ? data?.mrp : 0,
                    'useMrp': parameterDetails?.productUnitPrice ? data?.useMrp : false,
                    'pricePerUnit': parameterDetails?.productUnitPrice ? (data?.costPrice || 0) : 0,
                    'gstAmount': 0,
                    'netAmount': 0,
                    'discountPercentage': 0,
                    'discountAmount': 0,
                    'includeGst': form?.includeGst,
                    'productGstId': form?.includeGst ? data?.productGstId : null,
                    'productGst': form?.includeGst ? data?.productGst : '',
                    'hsnId': form?.includeGst ? data?.hsnId : null,
                    'hsn': form?.includeGst ? data?.hsn : '',
                    'locationId': form?.locationId,
                    'location': locationDetails?.find(el => el.id === form?.locationId)
                };
                // if (locationDetails && locationDetails?.length > 0) {
                //     let a = locationDetails?.filter(el => el.default);
                //     if (a?.length > 0) {
                //         d.locationId = a[0]?.id;
                //         d.location = a[0];
                //     } else {
                //         d.locationId = locationDetails[0]?.id;
                //         d.location = locationDetails[0];
                //     }
                // }

                if (parameterDetails?.inventoryTransaction) {
                    handleUnits(data);
                    getAvailableQty(data?.id, (data?.defaultSalesUnitId || data?.salesUnitId), d.locationId);
                    setLineForm(calculateLineTotal(d));
                    getProductBatch(calculateLineTotal(d), true);
                } else {
                    setLineForm(calculateLineTotal(d));
                    setSelected((prevState) => {
                        return [...prevState, calculateLineTotal(d)];
                    });
                }


                if (form?.includeGst && !data?.productGstId) {
                    setProductId('single');
                    onView(calculateLineTotal(d), false, selected?.length);
                    setErrorLineForm({
                        ...calculateLineTotal(d)
                    });
                    setLineError({
                        productGstId: 'Please select/enter a valid value in Product GST Code',
                        hsnId: !d?.hsnId && 'Please select/enter a valid value in HSN'
                    });
                    setTimeout(() => {
                        scrollToErrorSidebar(classes);
                        setTimeout(() => {
                            if (document.getElementById('DD-SSL-product-gst-code'))
                                document.getElementById('DD-SSL-product-gst-code').focus();
                        }, 100);
                    }, 100);
                } else {
                    setProductId(data.id);
                    setClickProductId(data.id);
                }
                setChangeSelected(!changeSelected);
            }
            dispatch({
                type: productActions.PRODUCT_PRICE_START,
                url: `/saledprice/${form?.customerId}/${data?.id}/${quantity === '' ? 1 : quantity}`
            });
        } else {
            setError({
                ...error,
                'customerId': 'Please select/enter a valid value in Customer'
            })
        }
    };


    const getProductBatch = async (res, lineSave = false) => {
        try {
            let f = { where: { ["and"]: [{ productId: res?.productId }, { availableStock: { gt: 0 } }] } };
            if (form?.salesType === 'Sale Return') {
                f = { where: { ["and"]: [{ productId: res?.productId }, { soldQuantity: { gt: 0 } }] } };
            }
            const response = await getRequest(`${process.env.REACT_APP_API_URL}/product-batch-numbers/byProduct/${res?.productId}?filter=${encodeURIComponent(JSON.stringify(f))}`);
            const data = response.data;
            let val = [];

            if (data && data.length) {
                val = data.map(item => ({
                    ...item,
                    availableStock: form?.salesType === 'Sale Return' ? -item.soldQuantity : item.availableStock,
                    fakeAvailableStock: form?.salesType === 'Sale Return' ? -item.soldQuantity : item.availableStock,
                    soldQuantity: 0,
                    originalSoldQuantity: 0
                }));
                setViewBatch(true);
            } else {
                val = [];
                setViewBatch(false);
            }
            setBatch(val);
            if (lineSave) {
                handleBulkClick(true, res, val, lineSave)
            }

            setAutoMark(false);
            return val;
        } catch (error) {
            setViewBatch(false);
            setBatch([]);
            setAutoMark(false);
            return [];
        }
    }

    const dispatchFilter = (topBar, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["and"]: [{ status: 'ACTIVE' }, { ["or"]: [{ transType: { eq: null } }, { transType: { eq: 'SALES' } }] }] };
        let or = { ["or"]: [] };
        let array = ['productName', 'productId', 'description', 'type', 'barcode', 'code'];
        if (search !== '') {
            if (topBar?.productSearch === 'both') {
                array = ['productName', 'code'];
            } else if (topBar?.productSearch === 'name') {
                array = ['productName'];
            } else if (topBar?.productSearch === 'code') {
                array = ['code'];
            } else if (topBar?.productSearch === 'mrp') {
                array = ['mrp'];
            }
            array.map((el) => {
                if (el === 'code' || el === 'mrp') {
                    return or['or'].push({ [el]: search.trim() })
                } else {
                    return or['or'].push({ [el]: { like: '%' + search.trim() + '%' } })
                }
            });
        }

        // if (topBar?.type === 'Category' && topBar?.categoryId) {
        //     filter['and'].push({ categoryId: parseInt(topBar?.categoryId) });
        // } else if (topBar?.groupId) {
        //     filter['and'].push({ productGroupId: parseInt(topBar?.groupId) });
        // }

        if (topBar?.groupId) {
            filter['and'].push({ productGroupId: parseInt(topBar?.groupId) });
        }
        if (topBar?.catalogueId) {
            filter['and'].push({ catalogueId: parseInt(topBar?.catalogueId) });
        }
        if (topBar?.categoryIds) {
            filter['and'].push({ categoryId: { inq: topBar?.categoryIds } });
        }

        if (or.or.length > 0) {
            filter['and'].push(or);
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'client-products',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip
            },
        });
    }

    const locationApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };

        if (search) {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
        }

        if (id) {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: productSetupActions.LOCATION_DETAILS_START, url: 'locations',
            filter: {
                where: !filter.or || filter.or.length === 0 ? {} : filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }

        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            if (name === 'customerId') {
                setForm({
                    ...form,
                    [name]: e.id,
                    'customer': e
                });
            } else if (name === 'mopId') {
                setForm({
                    ...form,
                    [name]: e.id,
                    'mop': e
                });
            } else if (name === 'discountAmount') {
                setForm({
                    ...form,
                    [name]: e,
                    'originalDiscountAmount': e,
                    'invoiceAmount': form.originalInvoiceAmount + parseFloat(form?.roundOffAmount || 0) - e,
                    'totalInvoiceAmount': form.originalInvoiceAmount - e,
                    'amountReceived': ''
                });
            } else if (name === 'roundOffMethod') {
                let value = 0;
                if (form?.totalInvoiceAmount && e !== '') {
                    if ((e === 'UP' && form?.salesType === 'Sale') || (e === 'DOWN' && form?.salesType === 'Sale Return')) {
                        value = Math.ceil(form?.totalInvoiceAmount || 0);
                    } else {
                        value = Math.floor(form?.totalInvoiceAmount || 0);
                    }
                }
                let rntAmt = value ? parseFloat(parseFloat(value - form?.totalInvoiceAmount).toFixed(2)) : 0
                let val = Math.abs(rntAmt);
                if ((form?.salesType === 'Sale' && e === 'DOWN') ||
                    (form?.salesType === 'Sale Return' && e === 'UP')) {
                    val = -(val);
                }
                setForm({
                    ...form,
                    [name]: e,
                    'roundOffAmount': val,
                    'amountReceived': ''
                });
                setChangeSelected(!changeSelected);
            } else {
                let data = {};
                if (name === 'includeGst') {
                    const newTodos = selected.map((el) => {
                        el.includeGst = e;
                        return calculateLineTotal(el);
                    });
                    setSelected(newTodos);
                    setChangeSelected(!changeSelected);
                } else if (name === 'roundOffAmount') {
                    setChangeSelected(!changeSelected);
                    data.amountReceived = '';
                }
                setForm({
                    ...form,
                    [name]: e,
                    ...data
                });
            }
        } else {
            let data = {};
            if (e.target.name === 'roundOffAmount' || e.target.name === 'discountAmount') {
                data.amountReceived = '';
            }
            if (e.target.name === 'roundOffAmount') {
                let val = Math.abs(e.target.value);
                if ((form?.salesType === 'Sale' && form?.roundOffMethod === 'DOWN') ||
                    (form?.salesType === 'Sale Return' && form?.roundOffMethod === 'UP')) {
                    val = -(val);
                }
                setForm({
                    ...form,
                    [e.target.name]: val ? val : '',
                    ...data
                });
                setChangeSelected(!changeSelected);
            } else {
                setForm({
                    ...form,
                    [e.target.name]: e.target.value,
                    ...data
                });
            }
        }
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(topBar, s);
    }

    const changeHandlerLine = (data, e, name = '', relation = '') => {
        if (relation !== '') {
            const newTodos = selected.map((el) => {
                if (el.productId === data.productId) {
                    let data = {};
                    if (name === 'unitId') {
                        if (e.id === el?.product?.salesUnitId) {
                            if (el?.product?.costPrice) {
                                data['pricePerUnit'] = el?.product?.costPrice || 0
                            }
                            if (el?.product?.mrp) {
                                data['maxRetailPrice'] = el?.product?.mrp || 0
                            }
                        } else {
                            data['pricePerUnit'] = 0;
                        }
                        data['discountPercentage'] = 0;
                        data['discountAmount'] = 0;
                        data['discountCalcAmount'] = 0;
                        data['discountPercAmount'] = 0;
                    }
                    setLineForm({ ...el, [name]: e.id, [relation]: e, ...data });
                    return { ...el, [name]: e.id, [relation]: e, ...data };
                }
                return el;
            });

            if (name === 'unitId') {
                if (data?.quantity) {
                    if (priceRef.current !== null) {
                        clearTimeout(priceRef.current);
                    }
                    priceRef.current = setTimeout(() => {
                        priceRef.current = null;
                        setProductId(data.productId);
                        dispatch({
                            type: productActions.PRODUCT_PRICE_START,
                            url: `/saledprice/${form?.customerId}/${data.productId}/${Math.abs(data?.quantity)}`
                        });
                    }, 1000);
                }
            }
            setSelected(newTodos);
            setChangeSelected(!changeSelected);
        } else {
            const newTodos = selected.map((el) => {
                if (el.productId === data.productId) {
                    let lie = el;
                    if (batch?.length && name === 'quantity') {
                        let findCom = findCombination(batch, e).changedItems;
                        if (form?.salesType === 'Sale Return') {
                            findCom = findCombinationCredit(batch, e).changedItems;
                        }

                        let batchDetails = [];
                        if (findCom?.length > 0) {
                            if (batch?.length) {
                                batch.map((el, i) => {
                                    el.soldQuantity = 0;
                                    el.originalSoldQuantity = 0;
                                    batch.splice(i, 1, el);
                                })
                            }
                            // setBatch(findCombination(batch, e).updatedItems);
                            // setSelectedBatchId(findCombination(batch, e).changedItems);
                            // let findBatch = findCombination(batch, e).updatedItems;

                            if (form?.salesType === 'Sale Return') {
                                setBatch(findCombinationCredit(batch, e).updatedItems);
                                setSelectedBatchId(findCombinationCredit(batch, e).changedItems);
                            } else {
                                setBatch(findCombination(batch, e).updatedItems);
                                setSelectedBatchId(findCombination(batch, e).changedItems);
                            }
                            let findBatch = findCombination(batch, e).updatedItems;
                            if (form?.salesType === 'Sale Return') {
                                findBatch = findCombinationCredit(batch, e).updatedItems;
                            }

                            let seBatch = findBatch.filter(le => findCom.includes(le.id));
                            seBatch && seBatch?.length > 0 && seBatch.map((el) => {
                                batchDetails.push({
                                    batchId: el.id,
                                    batch: el,
                                    quantity: el.soldQuantity,
                                    discountAmount: el.discountAmount
                                })
                            })
                        }

                        lie = {
                            ...calculateLineTotal(el),
                            batchDetails: batchDetails
                        };
                    }
                    setLineForm({ ...lie, [name]: e });
                    return { ...lie, [name]: e };
                }
                return el;
            });
            if (name === 'quantity' && e !== '') {
                if (priceRef.current !== null) {
                    clearTimeout(priceRef.current);
                }
                priceRef.current = setTimeout(() => {
                    priceRef.current = null;
                    setProductId(data.productId);
                    dispatch({
                        type: productActions.PRODUCT_PRICE_START,
                        url: `/saledprice/${form?.customerId}/${data.productId}/${Math.abs(e)}`
                    });
                }, 1000);
            }
            setSelected(newTodos);
            setChangeSelected(!changeSelected);
        }
    }

    const changeHandlerLineFocus = (data) => {
        setLineForm(data);
    }

    const changeHandlerLineForm = (e, name = '') => {
        if (name !== '') {
            if (name === 'unitId') {
                let data = {};
                if (name === 'unitId') {
                    if (e.id === lineForm?.product?.salesUnitId) {
                        if (lineForm?.product?.costPrice) {
                            data['pricePerUnit'] = lineForm?.product?.costPrice || 0
                        }
                        if (lineForm?.product?.mrp) {
                            data['maxRetailPrice'] = lineForm?.product?.mrp || 0
                        }
                    } else {
                        data['pricePerUnit'] = 0;
                    }
                    data['discountPercentage'] = 0;
                    data['discountAmount'] = 0;
                }
                getAvailableQty(lineForm?.productId, e.id, lineForm?.locationId, true);
                let d = {
                    ...lineForm,
                    [name]: e.id,
                    'unit': e,
                    ...data
                };
                setLineForm({
                    ...d, ...calculateLineTotal(d)
                });
                if (lineForm?.quantity !== '') {
                    if (priceRef.current !== null) {
                        clearTimeout(priceRef.current);
                    }
                    priceRef.current = setTimeout(() => {
                        priceRef.current = null;
                        setProductId('single');
                        dispatch({
                            type: productActions.PRODUCT_PRICE_START,
                            url: `/saledprice/${form?.customerId}/${lineForm?.productId}/${Math.abs(lineForm?.quantity)}`
                        });
                    }, 1000);
                }

            } else if (name === 'productGstId') {
                let data = {
                    ...lineForm,
                    [name]: e.id,
                    'productGst': e
                };
                setLineForm({
                    ...data,
                    ...calculateLineTotal(data)
                });
            } else if (name === 'hsnId') {
                setLineForm({
                    ...lineForm,
                    [name]: e.id,
                    'hsn': e
                });
            } else if (name === 'locationId') {
                setLineForm({
                    ...lineForm,
                    [name]: e.id,
                    'location': e
                });
                getAvailableQty(lineForm?.productId, lineForm?.unitId, e.id, true);
            } else if (name === 'quantity') {
                let data = {
                    ...lineForm,
                    [name]: e
                };
                setLineForm({
                    ...data,
                    ...calculateLineTotal(data)
                });
                if (e !== '') {
                    if (priceRef.current !== null) {
                        clearTimeout(priceRef.current);
                    }
                    priceRef.current = setTimeout(() => {
                        priceRef.current = null;
                        setProductId('single');
                        dispatch({
                            type: productActions.PRODUCT_PRICE_START,
                            url: `/saledprice/${form?.customerId}/${lineForm?.productId}/${Math.abs(e)}`
                        });
                    }, 1000);
                }
            } else if (name === 'includeGst') {
                let data = {
                    ...lineForm,
                    [name]: e
                };
                if (e) {
                    setLineForm({
                        ...data,
                        ...calculateLineTotal(data)
                    });
                } else {
                    setLineForm({
                        ...data,
                        igstPercentage: 0, sgstPercentage: 0, cgstPercentage: 0,
                        cgst: 0, sgst: 0, igst: 0, gstAmount: 0
                    });
                }
            } else {
                let data = {
                    ...lineForm,
                    [name]: e
                };
                setLineForm({
                    ...data,
                    ...calculateLineTotal(data)
                });
            }
        } else {
            let data = {
                ...lineForm,
                [e.target.name]: e.target.value
            };
            setLineForm({
                ...data,
                ...calculateLineTotal(data)
            });
        }
    }



    const handleLineSubmit = (e) => {
        e.preventDefault();
        let emptyDescription = emptyValidation('Description', lineForm?.description);
        let emptyUnit = emptyValidation('Unit', lineForm?.unitId, 'dropDown');
        let emptyPrice = customNumberValidation('Price', lineForm?.pricePerUnit);
        let emptyQuantity = emptyValidation('Quantity', lineForm?.quantity);
        let emptyAmount = emptyValidation('Line Amount', lineForm?.netAmount);
        let checkValidation = true;
        let emptyProductGst = emptyValidation('Product GST Code', lineForm?.productGstId, 'dropDown');
        let emptyHsn = emptyValidation('HSN', lineForm?.hsnId, 'dropDown');
        if ((lineForm?.includeGst && !emptyProductGst.isValid) || (lineForm?.includeGst && !emptyHsn.isValid)) {
            checkValidation = false;
        }

        let discountAgreeMents = true;
        let total = lineForm?.quantity * lineForm?.pricePerUnit;
        if (Math.abs(total) < Math.abs(lineForm?.discountCalcAmount)) {
            discountAgreeMents = false;
        }

        let batchDetails = [];
        if (selectedBatchId?.length > 0) {
            let seBatch = batch.filter(el => selectedBatchId.includes(el.id));
            seBatch && seBatch?.length > 0 && seBatch.map((el) => {
                batchDetails.push({
                    batchId: el.id,
                    batch: el,
                    quantity: el.soldQuantity,
                    discountAmount: el.discountAmount
                })
            })
        }

        let negativeQuantityCheck = { isValid: true, errors: '' };
        if (!parameterDetails?.negativeStock && parameterDetails?.inventoryTransaction) {
            let qty = availableQuantity - Math.abs(lineForm?.quantity);
            if (qty < 0) {
                negativeQuantityCheck = { isValid: false, errors: 'There is no stocks available' }
            }
        }

        let batchQuantityError = { isValid: true, errors: '' };
        if (batchDetails?.length > 0) {
            let batchQuantity = batchDetails?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.quantity || 0)), 0);
            if (batchQuantity !== parseFloat(lineForm?.quantity)) {
                batchQuantityError = { isValid: false, errors: 'Total Selected Batch quantity should equal Line Quantity' }
            }
        }

        setLineError({});
        if (emptyDescription.isValid &&
            emptyUnit.isValid && discountAgreeMents &&
            emptyPrice.isValid && emptyQuantity.isValid && emptyAmount.isValid && checkValidation && batchQuantityError.isValid && negativeQuantityCheck.isValid) {
            lineForm.quantity = parseFloat(lineForm?.quantity || 0);
            lineForm.discountAmount = parseFloat(lineForm?.discountAmount || 0);
            lineForm.discountPercentage = parseFloat(lineForm?.discountPercentage || 0);
            if (lineForm?.sgstAmount) {
                lineForm.sgstAmount = parseFloat(lineForm?.sgstAmount || 0);
            }
            if (lineForm?.cgstAmount) {
                lineForm.cgstAmount = parseFloat(lineForm?.cgstAmount || 0);
            }
            if (lineForm?.igstAmount) {
                lineForm.igstAmount = parseFloat(lineForm?.igstAmount || 0);
            }
            if (lineForm?.gstAmount) {
                lineForm.gstAmount = parseFloat(lineForm?.gstAmount || 0);
            }
            if (selectedBatchId?.length > 0) {
                let seBatch = batch.filter(el => selectedBatchId.includes(el.id));
                let batchDetails = [];
                seBatch && seBatch?.length > 0 && seBatch.map((el) => {
                    batchDetails.push({
                        batchId: el.id,
                        batch: el,
                        quantity: el.soldQuantity,
                        discountAmount: el.discountAmount
                    })
                })
                lineForm.batchDetails = batchDetails;
            }

            if (lineId !== '') {
                let index = selected.findIndex((d, i) => lineId === i);
                if (index >= 0) {
                    selected.splice(index, 1, lineForm);
                }
            } else {
                setSelected((prevState) => {
                    return [...prevState, lineForm];
                });
            }
            setErrorLineForm({});
            setChangeSelected(!changeSelected);
            setVisible(false);
        } else {
            setLineError({
                description: emptyDescription?.errors || false,
                unitId: emptyUnit?.errors || false,
                discountAgreeMents: !discountAgreeMents ? 'Discount amount is greater than Line amount, please correct it.' : false,
                pricePerUnit: emptyPrice?.errors || false,
                quantity: negativeQuantityCheck?.errors || emptyQuantity?.errors || false,
                productGstId: lineForm?.includeGst && emptyProductGst?.errors ? emptyProductGst?.errors : false,
                batchQuantity: batchQuantityError?.errors || '',
                hsnId: lineForm?.includeGst && emptyHsn?.errors ? emptyHsn?.errors : false
            });
        }
    }

    const onDelete = (id) => {
        if (lineForm?.productId !== id) {
            if (Object.keys(lineError)?.length > 0) {
                toast.dismiss();
                toast.error('Your last selected line having errors. Please update or remove lines');
                return false;
            }
        }

        // setSelected(prevState => {
        //     return prevState.filter((el, i) => el.productId !== id)
        // });
        setSelected(prev => {
            const updated = prev.filter(el => el.productId !== id);

            if (updated.length > 0) {
                setLineForm(updated[updated.length - 1]);
            } else {
                setLineForm({});
            }

            return updated;
        });
        setPriceList(prevState => {
            return prevState?.filter((el, i) => el.productId !== id)
        });
        setErrorLineForm({});
        // setLineForm({ ...Selected - 1 });
        setLineError({});
        setChangeSelected(!changeSelected);
    }

    const onView = async (data, view, lineId) => {
        if (lineForm?.productId !== data?.productId) {
            if (Object.keys(lineError)?.length > 0) {
                toast.dismiss();
                toast.error('Your last selected line having errors. Please update or remove lines');
                return false;
            }
        }

        setVisible(true);
        setView(view);
        let batch = [];
        setLineForm(calculateLineTotal(data));

        if (data?.productId) {
            batch = await getProductBatch({ ...data });
            getAvailableQty(data?.productId, data?.unitId, data?.locationId);
        }
        if (data?.batchDetails && data?.batchDetails?.length > 0) {
            setBatchDetails(data?.batchDetails);
            let a = [];
            data?.batchDetails?.map((el) => {
                a.push(el.batchId);
            });
            let updatedBatches = batch.map(batch => {
                const saleBatch = data?.batchDetails.find(s => s.batchId === batch.id);
                return {
                    ...batch,
                    batch: batch,
                    soldQuantity: saleBatch ? saleBatch.quantity : batch.soldQuantity
                };
            });

            if (view) {
                updatedBatches = data?.batchDetails.map(batchDetails => {
                    const saleBatch = batch.find(s => s.id === batchDetails.batchId);
                    return {
                        ...batchDetails.batch,
                        availableStock: saleBatch?.availableStock || 0,
                        soldQuantity: batchDetails.quantity
                    };
                });
            }

            setViewBatch(true);
            setBatch(updatedBatches);
            setSelectedBatchId(a);
        } else {
            setViewBatch(false);
            setBatch([]);
            setSelectedBatchId([]);
        }

        hsnApi('', data?.hsnId || '');
        setLineId(lineId);
    }

    const hsnApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };
        if (search !== undefined && search !== null && search !== '') {
            filter['or'].push({ hsnCode: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ description: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: gstActions.HSN_DETAILS_START, filter: {
                where: !filter.or || filter.or.length === 0 ? {} : filter,
                order: 'hsnCode asc',
                limit: 500,
                skip: 0
            },
        });
    }

    const handleQuantityChange = (data, v) => {
        if (lineForm?.productId && !checkLineForm(lineForm)) {
            toast.dismiss();
            toast.error('Your last selected line having errors. Please update or remove lines');
            return false;
        }

        let newTodos = [];
        if (v === 'decrease') {
            if ((form?.salesType === 'Sale Return' && parseFloat(data.quantity) >= -1) || (form?.salesType === 'Sale' && parseFloat(data.quantity) <= 1)) {
                setSelected(prevState => {
                    return prevState.filter((el, i) => el.productId !== data.productId)
                });
                setLineForm({});
                setChangeSelected(!changeSelected);
                return true;
            } else {
                newTodos = selected.map((el) => {
                    if (el.productId === data.productId) {

                        let qty = parseInt(el.quantity) - parseInt(1);
                        if (form?.salesType === 'Sale Return') {
                            qty = parseInt(el.quantity) + parseInt(1);
                        }
                        let lie = { ...el, 'quantity': qty };
                        if (priceRef.current !== null) {
                            clearTimeout(priceRef.current);
                        }
                        priceRef.current = setTimeout(() => {
                            priceRef.current = null;
                            setProductId(data.productId);
                            dispatch({
                                type: productActions.PRODUCT_PRICE_START,
                                url: `/saledprice/${form?.customerId}/${data.productId}/${Math.abs(qty)}`
                            });
                        }, 1000);

                        if (batch?.length) {
                            let findCom = findCombination(batch, qty).changedItems;
                            if (form?.salesType === 'Sale Return') {
                                findCom = findCombinationCredit(batch, qty).changedItems;
                            }

                            let batchDetails = [];
                            if (findCom?.length > 0) {
                                if (batch?.length) {
                                    batch.map((el, i) => {
                                        el.soldQuantity = 0;
                                        el.originalSoldQuantity = 0;
                                        batch.splice(i, 1, el);
                                    })
                                }
                                // setBatch(findCombination(batch, e).updatedItems);
                                // setSelectedBatchId(findCombination(batch, e).changedItems);
                                // let findBatch = findCombination(batch, e).updatedItems;


                                if (form?.salesType === 'Sale Return') {
                                    setBatch(findCombinationCredit(batch, qty).updatedItems);
                                    setSelectedBatchId(findCombinationCredit(batch, qty).changedItems);
                                } else {
                                    setBatch(findCombination(batch, qty).updatedItems);
                                    setSelectedBatchId(findCombination(batch, qty).changedItems);
                                }
                                let findBatch = findCombination(batch, qty).updatedItems;
                                if (form?.salesType === 'Sale Return') {
                                    findBatch = findCombinationCredit(batch, qty).updatedItems;
                                }

                                let seBatch = findBatch.filter(le => findCom.includes(le.id));
                                seBatch && seBatch?.length > 0 && seBatch.map((el) => {
                                    batchDetails.push({
                                        batchId: el.id,
                                        batch: el,
                                        quantity: el.soldQuantity,
                                        discountAmount: el.discountAmount
                                    })
                                })
                            }

                            lie = { ...el, 'quantity': qty, batchDetails: batchDetails };
                        }

                        setLineForm(lie);
                        return lie;
                    }
                    return el;
                });
            }
        } else {
            newTodos = selected.map((el) => {
                if (el.productId === data.productId) {
                    if (priceRef.current !== null) {
                        clearTimeout(priceRef.current);
                    }
                    let qty = parseInt(el.quantity) + parseInt(1);
                    if (form?.salesType === 'Sale Return') {
                        qty = parseInt(el.quantity) - parseInt(1);
                    }

                    priceRef.current = setTimeout(() => {
                        priceRef.current = null;
                        setProductId(data.productId);
                        dispatch({
                            type: productActions.PRODUCT_PRICE_START,
                            url: `/saledprice/${form?.customerId}/${data.productId}/${Math.abs(qty)}`
                        });
                    }, 1000);
                    let lie = { ...el, 'quantity': qty };
                    if (batch?.length) {
                        let findCom = findCombination(batch, qty).changedItems;
                        if (form?.salesType === 'Sale Return') {
                            findCom = findCombinationCredit(batch, qty).changedItems;
                        }

                        let batchDetails = [];
                        if (findCom?.length > 0) {
                            if (batch?.length) {
                                batch.map((el, i) => {
                                    el.soldQuantity = 0;
                                    el.originalSoldQuantity = 0;
                                    batch.splice(i, 1, el);
                                })
                            }
                            // setBatch(findCombination(batch, e).updatedItems);
                            // setSelectedBatchId(findCombination(batch, e).changedItems);
                            // let findBatch = findCombination(batch, e).updatedItems;


                            if (form?.salesType === 'Sale Return') {
                                setBatch(findCombinationCredit(batch, qty).updatedItems);
                                setSelectedBatchId(findCombinationCredit(batch, qty).changedItems);
                            } else {
                                setBatch(findCombination(batch, qty).updatedItems);
                                setSelectedBatchId(findCombination(batch, qty).changedItems);
                            }
                            let findBatch = findCombination(batch, qty).updatedItems;
                            if (form?.salesType === 'Sale Return') {
                                findBatch = findCombinationCredit(batch, qty).updatedItems;
                            }

                            let seBatch = findBatch.filter(le => findCom.includes(le.id));
                            seBatch && seBatch?.length > 0 && seBatch.map((el) => {
                                batchDetails.push({
                                    batchId: el.id,
                                    batch: el,
                                    quantity: el.soldQuantity,
                                    discountAmount: el.discountAmount
                                })
                            })
                        }

                        lie = { ...el, 'quantity': qty, batchDetails: batchDetails };
                    }
                    setLineForm(lie);
                    return lie;
                }
                return el;
            });
        }
        setSelected(newTodos);
        setChangeSelected(!changeSelected);
    }

    const handleSubmit = (status, payment = false) => {
        if (lineForm?.productId && !checkLineForm(lineForm)) {
            toast.dismiss();
            toast.error('Your last selected line having errors. Please update or remove lines');
            return false;
        }

        let a = []; let b = [];
        selected && selected?.length > 0 && selected?.map((element, i) => {
            return a.push({ ...element })
        });
        selected && selected?.length > 0 && selected?.map((element, i) => {
            return b.push({ ...element })
        });
        a?.length > 0 && a?.map((element, i) => {
            delete element.productGst;
            delete element.location;
            delete element.id;
            delete element.hsn;
            delete element.unit;
            delete element.product;
            delete element.discountPercAmount;
            delete element.discountCalcAmount;
            delete element.location;
            element.pricePerUnit = parseFloat(element.pricePerUnit);
            element.quantity = parseFloat(element.quantity);
            element.productGstId = element?.productGstId || null;
            element.hsnId = element?.hsnId || null;
            if (element?.batchDetails) {
                element?.batchDetails && element?.batchDetails?.length > 0 && element?.batchDetails?.map((e, i) => {
                    delete e.batch;
                    delete e.id;
                    element?.batchDetails.splice(i, 1, e);
                })
            }
            let mLines = { ...element };
            return a.splice(i, 1, mLines);
        });

        let storeSales = {
            customerId: form?.customerId,
            customerName: form?.customerName || form?.customer?.name || '',
            customerMobile: form?.customerMobile || form?.customer?.mobile || '',
            customerEmail: form?.customerEmail || form?.customer?.email || '',
            customerAddress: form?.customer?.address1 || '',
            customerCityId: form?.customer?.cityId || '',
            customerAreaId: form?.customer?.areaId || null,
            customerStateId: form?.customer?.stateId || '',
            customerCountryId: form?.customer?.countryId || '',
            customerPincodeId: form?.customer?.pincodeId || '',
            salesType: form?.salesType,
            posName: form?.pos?.posName || form?.posName,
            posId: form?.posId,
            billStatus: status,
            invoiceAmount: form?.invoiceAmount || 0,
            discountAmount: parseFloat(form?.discountAmount || 0),
            invoiceDate: form?.invoiceDate,
            gstAmount: parseFloat(form?.gstAmount || 0),
            priceIncludesTax: form?.priceIncludesTax,
            mopId: form?.mopId,
            mopName: form?.mop?.name,
            gstin: form?.customer?.gstin || '',
            partyGstId: form?.customer?.partyGstId || '',
            includeGst: form?.includeGst || false,
            currencyId: form?.customer?.currencyId || '',
            billFormat: form?.billFormat,
            storeSalesItems: a,
            storeSalesUserId: form?.storeSalesUserId,
            transactionDate: new Date(),
            comment: form?.comment || '',
            isReturnWithReceipt: changeReceipt,
            billRefNum: form?.billRefNum || '',
            roundOffAmount: parseFloat(form?.roundOffAmount || 0),
            roundOffMethod: form?.roundOffMethod || null,
            isMixedPayment: form?.mixedPayment || false
        };
        // b?.length > 0 && b?.map((element, i) => {
        //     delete element.productGst; delete element.id;
        //     delete element.hsn;
        //     delete element.unit;
        //     delete element.product;
        //     delete element.discountPercAmount;
        //     delete element.discountCalcAmount;
        //     element.fullySettled = true;
        //     element.pricePerUnit = parseFloat(element.pricePerUnit);
        //     element.productGstId = element?.productGstId || null;
        //     element.hsnId = element?.hsnId || null;
        //     element.amountToSettle = element.netAmount;
        //     let mLines = { ...element };
        //     return b.splice(i, 1, mLines);
        // });

        let customerPayment = [];

        if (form?.mixedPayment && form?.salesType !== 'Sale Return') {
            form?.payments?.length > 0 && form?.payments?.map((el) => {
                return customerPayment.push({
                    date: form?.invoiceDate,
                    paymentAmount: parseFloat(el.amount),
                    reference: "",
                    markedAmount: parseFloat(el.amount),
                    description: "",
                    paymentStatus: "CONFIRMED",
                    mopId: el?.mopId || null,
                    customerId: form?.customerId,
                    currencyId: form?.customer?.currencyId
                });
            })
        } else {
            customerPayment = [{
                date: form?.invoiceDate,
                paymentAmount: form?.salesType === 'Sale Return' ? parseFloat(form?.invoiceAmount) : parseFloat(form?.invoiceAmount) <
                    parseFloat(form?.amountReceived) ? parseFloat(form?.invoiceAmount) : parseFloat(form?.amountReceived),
                reference: "",
                markedAmount: form?.salesType === 'Sale Return' ? parseFloat(form?.invoiceAmount) : parseFloat(form?.invoiceAmount) <
                    parseFloat(form?.amountReceived) ? parseFloat(form?.invoiceAmount) : parseFloat(form?.amountReceived),
                description: "",
                paymentStatus: "CONFIRMED",
                mopId: form?.mopId || null,
                customerId: form?.customerId,
                currencyId: form?.customer?.currencyId
                // items: b
            }];
        }
        let data = {
            storeSales: storeSales
        }

        if (storeSales?.billStatus === 'CONFIRMED') {
            data.customerPayments = customerPayment;
        }

        if (form?.isReturnWithReceipt && returnProducts?.length !== b?.length) {
            let returnProductsSelected = b.filter((el) => { return returnProducts.find(e => e === el.id && !el.isReturned) });
            data.storeSales.discountAmount = 0;
            returnProductsSelected?.length > 0 && returnProductsSelected?.map((element, i) => {
                delete element.productGst;
                delete element.location;
                delete element.id;
                delete element.hsn;
                delete element.unit;
                delete element.product;
                delete element.discountPercAmount;
                delete element.discountCalcAmount;
                element.lineNumber = parseFloat(i + 1);
                element.pricePerUnit = parseFloat(element.pricePerUnit);
                element.quantity = parseFloat(element.quantity);
                element.productGstId = element?.productGstId || null;
                element.hsnId = element?.hsnId || null;
                if (element?.batchDetails) {
                    element?.batchDetails && element?.batchDetails?.length > 0 && element?.batchDetails?.map((e, i) => {
                        delete e.batch;
                        delete e.id;
                        element?.batchDetails.splice(i, 1, e);
                    })
                }
                let mLines = { ...element };
                return returnProductsSelected.splice(i, 1, mLines);
            });
            data.storeSales.storeSalesItems = returnProductsSelected;
            if (data?.storeSales?.billStatus === 'CONFIRMED') {
                data.customerPayments[0].paymentAmount = data.storeSales.invoiceAmount;
                data.customerPayments[0].markedAmount = data.storeSales.invoiceAmount;
            }
            dispatch({
                type: form?.id ? crudActions.EDIT_DETAILS_START : crudActions.CREATE_DETAILS_START,
                url: 'store-sales',
                title: 'Store Sales',
                details: data,
                id: form?.id + '/' + (form?.customerPayment?.id || 0)
            });

            dispatch({
                type: crudActions.UPDATE_START,
                url: `/store-sales-items/return`,
                details: { itemIds: returnProducts }
            });
        } else {
            dispatch({
                type: form?.id ? crudActions.EDIT_DETAILS_START : crudActions.CREATE_DETAILS_START,
                url: 'store-sales',
                title: 'Store Sales',
                details: data,
                id: form?.id + '/' + (form?.customerPayment?.id || 0)
            });

            if (form?.isReturnWithReceipt) {
                dispatch({
                    type: crudActions.UPDATE_START,
                    url: `/updateFullyReturnByCashReceiptNumber/${form?.cashReceiptNumber}`,
                    details: {}
                });
            }
        }
    }

    const handleNameDisplay = (v) => {
        storageSetItem('posProductView', v);
        setShowNameDesc(v);
    }

    useEffect(() => {
        if (myProductdetails) {
            setProducts(myProductdetails)
        }
    }, [myProductdetails]);


    const classes = customStyles();

    const changeLineProductGst = (lineId, form) => {
        let index = selected.findIndex((d, i) => lineId === i);
        if (index >= 0) {
            selected.splice(index, 1, form);
        }
        toast.dismiss();
        toast.success('Line Product GST Updated');
        setSelected([...selected]);
        setChangeSelected(!changeSelected);
        setVisible(false);
    }

    const handleChangeCashReceipt = (id) => {
        setChangeReceipt(true);
        dispatch({
            type: crudActions.READ_DETAILS_START,
            id: id,
            url: "store-sales"
        });
    }

    const changeHandlerTopBar = (name, value) => {
        let data = {
            ...topBar,
            [name]: value
        }
        if (name === 'type') {
            storageSetItem('posSearchType', value);
        }
        setTopBar(data);
        dispatchFilter(data);
    }

    const handleCheckBoxClick = (value) => {
        let a = [];
        if (form?.isReturnWithReceipt && value.length !== selected?.length) {
            selected && selected?.length > 0 && selected?.map((element, i) => {
                return a.push({ ...element })
            });
            form.roundOffMethod = '';
            form.roundOffAmount = 0;
            let returnProductsSelected = a.filter((el) => { return value.find(e => e === el.id) });
            calculateTotal(returnProductsSelected, true);
        } else {
            form.roundOffMethod = form.duplicateRoundOffMethod;
            form.roundOffAmount = form.duplicateRoundOffAmount;
            calculateTotal(selected);
        }
        setReturnProducts(value);
    }

    const handleViewType = (t) => {
        setViewType(t);
        setActiveInputs('');
        setToggle(false);
    }

    const handleFilter = (catalogueId, categoryIds) => {
        let data = {
            ...topBar,
            catalogueId: catalogueId,
            categoryIds: categoryIds
        };
        dispatchFilter(data);
        setTopBar(data)
    }

    const handleToggle = () => {
        setToggle(!toggle);
    }

    const handleFormUpdate = (payments) => {
        setForm({
            ...form,
            amountReceived: payments && payments?.length > 0 ? payments?.reduce((a, v) => a = parseFloat(a) + parseFloat(v.amount), 0) : 0,
            payments: payments
        });
    }

    const findCombination = (items, quantity) => {
        let updatedItems = items.map(item => ({ ...item }));
        let changedItems = [];
        for (let item of updatedItems) {
            if (quantity <= 0) break;

            let sellQty = Math.min((item?.availableStock || 0), quantity);
            if (sellQty > 0) {
                item.soldQuantity += parseFloat(sellQty);
                quantity -= sellQty;
                changedItems.push(item.id); // Collect updated item
            }
        }

        return { updatedItems, changedItems };
    }

    const handleBulkClick = (value, lineForm, batch, lineSave = false) => {
        if (batch?.length) {
            batch.map((el, i) => {
                el.soldQuantity = 0;
                el.originalSoldQuantity = 0;
                batch.splice(i, 1, el);
            })
        }

        if (value) {
            if (form?.salesType === 'Sale Return') {
                setBatch(findCombinationCredit(batch.filter(el => el.locationId === lineForm?.locationId), lineForm?.quantity).updatedItems);
                setSelectedBatchId(findCombinationCredit(batch.filter(el => el.locationId === lineForm?.locationId), lineForm?.quantity).changedItems);
            } else {
                setBatch(findCombination(batch.filter(el => el.locationId === lineForm?.locationId), lineForm?.quantity).updatedItems);
                setSelectedBatchId(findCombination(batch.filter(el => el.locationId === lineForm?.locationId), lineForm?.quantity).changedItems);
            }
            if (lineSave) {
                setSelected((prevState) => {
                    let lie = calculateLineTotal(lineForm);
                    if (batch?.length) {
                        let findCom = findCombination(batch, lineForm?.quantity).changedItems;
                        let findComUpda = findCombination(batch, lineForm?.quantity).updatedItems;
                        if (form?.salesType === 'Sale Return') {
                            findCom = findCombinationCredit(batch, lineForm?.quantity).changedItems;
                            findComUpda = findCombinationCredit(batch, lineForm?.quantity).updatedItems;
                        }
                        let batchDetails = [];
                        if (findCom?.length > 0) {
                            let seBatch = findComUpda.filter(el => findCom.includes(el.id));
                            seBatch && seBatch?.length > 0 && seBatch.map((el) => {
                                batchDetails.push({
                                    batchId: el.id,
                                    batch: el,
                                    quantity: el?.soldQuantity,
                                    discountAmount: el.discountAmount
                                })
                            })
                        }
                        lie = {
                            ...calculateLineTotal(lineForm),
                            batchDetails: batchDetails
                        };
                    }
                    return [...prevState, lie];
                });
            }
        } else {
            const newBatch = batch.map(el => {
                return { ...el, soldQuantity: el.originalSoldQuantity };
            });
            setBatch(newBatch);
            setSelectedBatchId([]);
        }
    }

    const findCombinationCredit = (items, quantity) => {
        let updatedItems = items.map(item => ({ ...item }));
        let changedItems = [];

        for (let item of updatedItems) {
            if (quantity > 0) break;

            let sellQty = Math.max((item?.availableStock || 0), quantity);
            if (sellQty < 0) {
                item.soldQuantity -= sellQty;
                quantity += sellQty;
                item.soldQuantity = -item.soldQuantity;
                changedItems.push(item.id); // Collect updated item
            }
        }

        return { updatedItems, changedItems };
    }

    const changeHandlerBatch = (data, e, name) => {
        const newTodos = batch.map((el) => {
            if (el.batchNumber === data.batchNumber) {
                return { ...el, [name]: e };
            }
            return el;
        });
        setBatch(newTodos);
    }



    const handleBatchClick = (id, lineForm) => {
        const isSelected = selectedBatchId.includes(id);
        let newSelected;

        if (!isSelected) {
            // Checked (select)
            newSelected = [...selectedBatchId, id];

        } else {
            // UnChecked (deselect)
            newSelected = selectedBatchId.filter(batchId => batchId !== id);
        }

        // if (updateSoldQty(newSelected, id, !isSelected, form)) {
        //     setSelectedBatchId(newSelected);
        // } else {

        // }
        if (form?.salesType === 'Sale' && updateSoldQty(newSelected, id, !isSelected, lineForm)) {
            setSelectedBatchId(newSelected);
        } else if (form?.salesType === 'Sale Return' && updateSoldQtyCredit(newSelected, id, !isSelected, lineForm)) {
            setSelectedBatchId(newSelected);
        }
    };

    const getAvailableQty = async (id, unitId, locationId, view = false) => {
        try {
            const response = await getRequest(`${process.env.REACT_APP_API_URL}/stock-on-hands/byProduct/${id}/${unitId}/${locationId}`);
            const data = response.data;
            // let val = [];

            if (data?.length && data[0]?.units?.length) {
                let qty = data[0]?.units.find(obj => obj.hasOwnProperty(unitId))?.[unitId];
                setAvailableQuantity(parseFloat(parseFloat(qty).toFixed(2)));
            } else {
                setAvailableQuantity(0);
            }
            if (data?.length && data[0]?.cUnits?.length) {
                let qty = data[0]?.cUnits.find(obj => obj.hasOwnProperty(unitId))?.[unitId];
                let divied = data[0]?.cUnits.find(obj => obj.hasOwnProperty(unitId)).divied;
                if (view) {
                    let a = [];
                    batch.map((el, i) => {
                        el.availableStock = divied ? parseFloat(parseFloat(el.fakeAvailableStock / qty).toFixed(2)) : parseFloat(parseFloat(qty * el.fakeAvailableStock).toFixed(2));
                        el.soldQuantity = view ? 0 : el.soldQuantity;
                        el.originalSoldQuantity = view ? 0 : el.originalSoldQuantity;
                        a.push(el);
                    });
                    setBatch(a);
                    setSelectedBatchId([])
                }
            }
        } catch (error) {
            console.log(error);
        }
    }


    const updateSoldQty = (newSelected, id, isChecked, form) => {
        let fBatch = batch.filter(el => newSelected.includes(el.id));
        let sQuantity = fBatch.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.soldQuantity || 0), 0);
        if (sQuantity < Math.abs(form?.quantity)) {
            let qty = Math.abs(form?.quantity) - sQuantity;
            const newBatch = batch.map(el => {
                if (el.id === id) {
                    if (isChecked) {
                        // Checked: add availableQty
                        return { ...el, soldQuantity: el.availableStock < qty ? ((el?.soldQuantity || 0) + (el?.availableStock || 0)) : qty };
                    } else {
                        // UnChecked: revert to originalSoldQty
                        return { ...el, soldQuantity: el.originalSoldQuantity };
                    }
                }
                return el;
            });
            setBatch(newBatch);
            return true;
        }
        return false
    };

    const updateSoldQtyCredit = (newSelected, id, isChecked, form) => {
        const limit = parseFloat(form?.quantity); // Ex: -20

        // Get total sold quantity from selected batches
        const selectedBatches = batch.filter(el => newSelected.includes(el.id));
        const totalSoldQty = selectedBatches.reduce((sum, el) => sum + parseFloat(el?.soldQuantity || 0), 0);

        if (totalSoldQty > limit) {
            const remainingQty = limit - totalSoldQty; // Ex: -20 - (-10) = -10

            const newBatch = batch.map(el => {
                if (el.id === id) {
                    if (isChecked) {
                        const available = parseFloat(el?.availableStock || 0); // negative
                        const assignQty = Math.max(available, remainingQty); // most negative value
                        return { ...el, soldQuantity: assignQty };
                    } else {
                        return { ...el, soldQuantity: el.originalSoldQuantity };
                    }
                }
                return el;
            });
            setBatch(newBatch);
            return true;
        }

        // Limit reached or exceeded
        return false;
    };

    const handleUnits = (data) => {
        let filter = {
            where: {
                and: [{ productId: data?.id }, { or: [{ unitId: (data?.defaultSalesUnitId || data?.salesUnitId) }, { toUnitId: (data?.defaultSalesUnitId || data?.salesUnitId) },] }]
            }
        }; let uFilter = {
            where: {
                or: [{ unitId: (data?.defaultSalesUnitId || data?.salesUnitId) }, { toUnitId: (data?.defaultSalesUnitId || data?.salesUnitId) }]
            }
        };
        let a = [data?.salesUnitId, data?.skuUnitId, data?.defaultSalesUnitId];

        getRequest(`${process.env.REACT_APP_API_URL}/product-unit-conversions/?filter=${encodeURIComponent(JSON.stringify(filter))}`)
            .then(response => {
                let da = response.data;
                if (da && da.length > 0) {
                    da.forEach(el => {
                        a.push(el.unitId)
                        a.push(el.toUnitId);
                    });
                }
                return getRequest(`${process.env.REACT_APP_API_URL}/unit-conversions/?filter=${encodeURIComponent(JSON.stringify(uFilter))}`);
            }).then(uResponse => {
                let uData = uResponse.data;
                if (uData && uData.length > 0) {
                    uData.forEach(el => {
                        a.push(el.unitId)
                        a.push(el.toUnitId)
                    });
                }

                const filtered = unitMesurementdetails.filter(el => a.includes(el.id));
                setUnits(prev => {
                    const current = prev[data?.id] || [];  // Get existing array or empty array
                    return {
                        ...prev,
                        [data?.id]: [...current, ...filtered]  // Append `filtered` array
                    };
                });
            })
            .catch(error => {
                console.error("Error fetching data", error);
            });
    }


    return (
        <>
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.storeSales)}>
                <PrimaryCard
                    title={
                        <>
                            {PaymentProcess ? 'Process Payment' : (form?.salesType === 'Sale Return' ? form?.salesType : `POS Sales`)}
                            <Image
                                preview={false}
                                className={clsx(classes.logoImgStoreSales, classes.logoImg)}
                                src={logoImg}
                            />
                            <NavLink to={'/sales/sales-management/store-sales'} className={classes.storesalesclose}>
                                <Image src={closeImg} preview={false} className={classes.cursor} />
                            </NavLink>
                        </>
                    }
                    component={
                        <div className={clsx(classes.heightFull, classes.storeSalesRow, { [classes.togggleBarcode]: viewType === 'barcode' && !PaymentProcess }, { [classes.togggleOpen]: toggle })}>
                            <div span={8} className={clsx(classes.heightFull, classes.storeSalesLeftSide)}>
                                <LeftSide
                                    visible={visible}
                                    mopDetails={mopDetails}
                                    form={form} errorLineForm={errorLineForm}
                                    lineForm={lineForm}
                                    paymentProcess={PaymentProcess}
                                    salesType={form?.salesType}
                                    productId={productId}
                                    clickProductId={clickProductId}
                                    handleSearch={(value) => setSearch(value)}
                                    clientProductcatalogueDetails={clientProductcatalogueDetails}
                                    productGroupDetails={productGroupDetails}
                                    details={getList}
                                    search={search}
                                    handleNameDisplay={(v) => handleNameDisplay(v)}
                                    showNameDesc={showNameDesc}
                                    loadMore={loadMore}
                                    headerView={headerView}
                                    loadMoreContent={loadMoreContent}
                                    changeHandler={(e, name = '') => changeHandler(e, name)}
                                    changeHandlerLine={(data, e, name = '', relation = '') => changeHandlerLine(data, e, name, relation)}
                                    loadMoreTask={() => loadMoreTask()}
                                    selected={selected}
                                    businessDetails={businessDetails}
                                    handleGridClick={(data, q = '') => handleClick(data, q)}
                                    loadTasks={() => dispatchFilter(topBar)}
                                    customObject={(details, id) => customObject(details, id)}
                                    handleQuantityChange={(data, v) => handleQuantityChange(data, v)}
                                    roleManagement={roleManagement}
                                    checkCRUDPermission={checkCRUDPermission}
                                    checkComponentPermission={checkComponentPermission}
                                    topBar={topBar}
                                    activeInputs={activeInputs}
                                    handleActiveInputs={(name) => setActiveInputs(name)}
                                    changeHandlerTopBar={(name, value) => changeHandlerTopBar(name, value)}
                                    handleNewSales={() => handleNewSales()}
                                    handlePaymentProcess={(d) => handlePaymentProcess(d)}
                                    returnProducts={returnProducts}
                                    loader={createLoader || editLoader}
                                    handleSubmit={(status, payment) => handleSubmit(status, payment)}
                                    handlePrint={(v) => setPrint(v)}
                                    viewType={viewType}
                                    parameterDetails={parameterDetails}
                                    handleViewType={(t) => handleViewType(t)}
                                    idNamingConversion={(name, place = 'menu', fieldType = '') => idNamingConversion(name, place, fieldType)}
                                    handleFilter={(catalogueId, categoryIds) => handleFilter(catalogueId, categoryIds)}
                                    handleFormUpdate={(data) => handleFormUpdate(data)}
                                />
                                <NavLink to="#" onClick={() => handleToggle()} className={classes.toggleProductViewLeft}>Close Product</NavLink>
                            </div>
                            <div span={16} className={clsx(classes.heightFull, classes.storeSalesRightSide)}>
                                <RightSide
                                    viewType={viewType}
                                    salesType={form?.salesType}
                                    status={status}
                                    handleNewSales={() => handleNewSales()}
                                    paymentProcess={PaymentProcess}
                                    changeHandler={(e, name = '') => changeHandler(e, name)}
                                    changeHandlerLine={(data, e, name = '', relation = '') => changeHandlerLine(data, e, name, relation)}
                                    changeHandlerLineFocus={(data) => changeHandlerLineFocus(data)}
                                    form={form}
                                    showNameDesc={showNameDesc}
                                    unitMesurementdetails={unitMesurementdetails}
                                    selected={selected}
                                    error={error}
                                    classes={classes}
                                    clsx={clsx}
                                    headerView={headerView}
                                    handleActiveInputs={(name) => setActiveInputs(name)}
                                    productApi={(search = '', id = '') => productApi(search, id)}
                                    handleHeaderView={(d) => { setpaymentProcess(d); setHeaderView(d); setError({}) }}
                                    handleQuantityChange={(data, v) => handleQuantityChange(data, v)}
                                    customerDetails={customerDetails}
                                    customObject={(details, id) => customObject(details, id)}
                                    onEdit={(data, i) => onView(data, false, i)}
                                    onView={(data, i) => onView(data, true, i)}
                                    onDelete={(id) => onDelete(id)}
                                    handleSubmit={(status, payment) => handleSubmit(status, payment)}
                                    handlePaymentProcess={(d) => handlePaymentProcess(d)}
                                    readLoader={readLoader}
                                    lineId={lineId}
                                    myProductdetails={products}
                                    loader={createLoader || editLoader}
                                    productId={productId}
                                    clickProductId={clickProductId}
                                    productGstdetails={productGstdetails}
                                    hsnDetails={hsnDetails}
                                    changeLineProductGst={(lineId, form) => changeLineProductGst(lineId, form)}
                                    handleGridClick={(data, q = '') => handleClick(data, q)}
                                    visible={visible}
                                    roleManagement={roleManagement}
                                    checkCRUDPermission={checkCRUDPermission}
                                    checkComponentPermission={checkComponentPermission}
                                    dispatch={dispatch}
                                    customerApi={(search = '', id = '') => customerApi(search, id)}
                                    handleChangeCashReceipt={(id) => handleChangeCashReceipt(id)}
                                    returnProducts={returnProducts}
                                    handleCheckBoxClick={(value) => handleCheckBoxClick(value)}
                                    activeInputs={activeInputs}
                                    handlePrint={(v) => setPrint(v)}
                                    lineForm={lineForm}
                                    parameterDetails={parameterDetails}
                                    handleViewType={(t) => handleViewType(t)} units={units}
                                    idNamingConversion={(name, place = 'menu', fieldType = '') => idNamingConversion(name, place, fieldType)}
                                />
                                <NavLink to="#" onClick={() => handleToggle()} className={classes.toggleProductView}>Select Product</NavLink>
                            </div>
                        </div>
                    }
                /></div>
            <LineForm
                visible={visible}
                form={lineForm}
                lineId={lineId}
                parentForm={form}
                error={lineError}
                salesType={form?.salesType}
                view={view}
                headerView={headerView}
                onEdit={(data) => onView(data, false, lineId)}
                onUpdate={() => setVisible(!visible)}
                productGstdetails={productGstdetails}
                unitMesurementdetails={unitMesurementdetails}
                hsnDetails={hsnDetails}
                myProductdetails={myProductdetails}
                classes={classes}
                handleClose={() => setVisible(false)}
                customObject={(details, id) => customObject(details, id)}
                changeHandlerLine={(e, name) => changeHandlerLineForm(e, name)}
                handleLineSubmit={(e) => handleLineSubmit(e)}
                locationDetails={locationDetails}
                handleViewBatch={(d) => setViewBatch(d)}
                handleBulkClick={(v, form, batch) => handleBulkClick(v, form, batch)}
                parameterDetails={parameterDetails}
                viewBatch={viewBatch}
                batch={batch}
                selectedBatchId={selectedBatchId}
                handleClick={(id, lineForm) => handleBatchClick(id, lineForm)}
                setBatch={(d) => setBatch(d)}
                autoMark={autoMark}
                setAutoMark={(d) => setAutoMark(d)}
                changeHandlerBatch={(data, value, name) => changeHandlerBatch(data, value, name)}
                availableQuantity={availableQuantity}
                hsnApi={(s) => hsnApi(s)}
                units={units} />
            {
                print && <SalesModal
                    visible={print}
                    classes={classes}
                    handleClose={() => setPrint(false)}
                    previewType={'storeSales'}
                    details={{
                        ...form,
                        business: { ...businessDetails, name: businessDetails?.businessName, gstNumber: businessDetails?.gst },
                        storeSalesItems: form?.isReturnWithReceipt ?
                            selected?.filter((el) => { return returnProducts.find(e => e === el.id && !el.isReturned) }).map((element, i) => {
                                element.lineNumber = parseFloat(i + 1);
                                return element
                            }) : selected
                    }}
                    ref={saleModalRef}
                />
            }
            <CustomModal
                onClose={(v) => setNewSales(v)}
                yesButton={'Yes'}
                noButton={'No'}
                title={form?.salesType === 'Sale Return' ? 'New Sale Return' : 'New Sales'}
                visible={newSales}
                yesId={idNamingConversion('OK', 'storeSales', 'Button')}
                noId={idNamingConversion('Cancel', 'storeSales', 'Button')}
                loading={createLoader || editLoader}
                onOpen={() => handleNewSalesConfirm()}
                text={'Would you like to save this record'}
            />
        </>
    )
}

export default StoreSalesCreate;